import { render, staticRenderFns } from "./StudentTitles.vue?vue&type=template&id=4e87b05d"
import script from "./StudentTitles.vue?vue&type=script&lang=js"
export * from "./StudentTitles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports